import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", light = false }) => (
  <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="logo-home-link">
    <div className={`h-9 w-9 rounded-xl flex items-center justify-center ${light ? "bg-white" : "bg-primary"} transition-transform group-hover:scale-105`}>
      <svg viewBox="0 0 24 24" className={`h-5 w-5 ${light ? "text-primary" : "text-white"}`} fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M2 16c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2 2-2 4-2" strokeLinecap="round" />
        <path d="M2 11c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2 2-2 4-2" strokeLinecap="round" opacity="0.55" />
        <circle cx="12" cy="5" r="2" opacity="0.85" />
      </svg>
    </div>
    <div className="leading-none">
      <div className={`font-heading font-semibold tracking-tight text-[15px] ${light ? "text-white" : "text-slate-900"}`}>CRISTALDA</div>
      <div className={`text-[9px] font-bold uppercase tracking-[0.32em] ${light ? "text-white/70" : "text-secondary"}`}>Experience</div>
    </div>
  </Link>
);
